/**
 * @file useDesignFlash.ts
 * @description Подсветка карточки дизайна после «Создать», «Применить» и
 * «Обновить» (решения 2026-10-12): прокрутка к карточке и обводка на 2 с —
 * тот же приём, что у групп настроек (`data-flash`).
 */

import { useCallback, useEffect, useState } from "react";

/** Сколько держится подсветка. */
export const DESIGN_FLASH_MS = 2000;

export function useDesignFlash(): { flashId: string | null; flash: (id: string) => void } {
  const [flashId, setFlashId] = useState<string | null>(null);

  useEffect(() => {
    if (!flashId) return;
    // Карточка уже наверху списка (порядок «в работе» первым) — докрутить, если панель прокручена.
    const frame = window.requestAnimationFrame(() => {
      document.getElementById(`design-${flashId}`)?.scrollIntoView?.({ block: "nearest", behavior: "smooth" });
    });
    const timer = window.setTimeout(() => setFlashId(null), DESIGN_FLASH_MS);
    return () => {
      window.cancelAnimationFrame(frame);
      window.clearTimeout(timer);
    };
  }, [flashId]);

  const flash = useCallback((id: string) => setFlashId(id), []);
  return { flashId, flash };
}
